import axios from 'axios'
import { config } from './cognitoConfig'
import { logout } from './cognitoAuth'

// Variable para evitar múltiples redirecciones simultáneas
let isRedirecting = false

/**
 * Configura interceptores globales de axios para manejar
 * expiración de tokens y errores de autenticación
 */
export function setupAxiosInterceptors() {
  
  // Interceptor de REQUEST: Agregar token automáticamente a todas las peticiones
  axios.interceptors.request.use(
    (config) => {
      const token = localStorage.getItem('token')
      
      // Si hay token disponible, agregarlo a los headers
      if (token && config.headers) {
        config.headers.Authorization = `Bearer ${token}`
      }
      
      return config
    },
    (error) => {
      return Promise.reject(error)
    }
  )

  // Interceptor de RESPONSE: Detectar errores de autenticación
  axios.interceptors.response.use(
    // Si la respuesta es exitosa, simplemente retornarla
    (response) => response,
    
    // Si hay error, verificar si es de autenticación
    (error) => {
      // Si ya estamos redirigiendo, no hacer nada más
      if (isRedirecting) {
        return Promise.reject(error)
      }

      // Verificar si es un error de autenticación (401 o 403)
      if (error.response && (error.response.status === 401 || error.response.status === 403)) {
        console.log('🔐 Token expirado o inválido. Redirigiendo a login...')
        
        // Marcar que estamos redirigiendo
        isRedirecting = true
        
        // Limpiar localStorage
        logout()
        
        // Redirigir a Cognito login después de un breve delay
        setTimeout(() => {
          const loginUrl = config.getLoginUrl()
          window.location.href = loginUrl
        }, 100)
        
        // Resetear flag después de 2 segundos (por si algo falla)
        setTimeout(() => {
          isRedirecting = false
        }, 2000)
      }
      
      return Promise.reject(error)
    }
  )
}
